import axios from 'axios';
import { toast } from 'components/elements/molecules/Toast/Toast';

export function syncCourses(payload) {
  return (dispatch) => {
    return axios
      .post('/api/duplicateCourse/syncCourses', payload)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((error) => {
        console.log('Error while syncing course', error);
        toast('Error while syncing course', {
          type: 'error',
        });
        throw error;
      });
  };
}
